import { Button, TextInput } from '@uplift/ui-v2';
import { Form, useFormikContext } from 'formik';
import { useFormStyles } from '../form-styles';
import { useL10n } from '@uplift/hooks';
import { useMemo, useState } from 'react';
import { Add } from '@mui/icons-material';
import { NameFormType } from './use-name-form.hook';

export const NameForm = () => {
  const l10n = useL10n();
  const { classes } = useFormStyles();
  const formik = useFormikContext<NameFormType>();
  const [ showMiddleName, setShowMiddleName ] = useState(!!formik.values.middleName);

  const middleName = useMemo(() => {
    if (showMiddleName) {
      return (
        <TextInput
          label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.middleName)}
          name="middleName"
          fullWidth
        />
      );
    }

    return (
      <Button
        variant="text"
        startIcon={<Add />}
        color="secondary"
        onClick={() => setShowMiddleName(true)}
        className={classes.middleNameButton}
      >
        {l10n.accountSettings.isOptional(l10n.accountSettings.profile.addMiddle)}
      </Button>
    );
  }, [ classes.middleNameButton, l10n.accountSettings, showMiddleName ]);

  return (
    <Form className={classes.formGroup}>
      <TextInput
        label={l10n.accountSettings.firstName}
        name="firstName"
        fullWidth
      />
      {middleName}
      <TextInput
        label={l10n.accountSettings.lastName}
        name="lastName"
        fullWidth
      />
      <TextInput
        label={l10n.accountSettings.isOptional(l10n.accountSettings.profile.preferredName)}
        name="preferredName"
        fullWidth
      />
    </Form>
  );
};
